const branches = 
{
  branches: {
    pageHeader: 'Filiais',
    addBranchOffice: '+ Adicionar filial',
    name: 'Nome',
    city: 'Cidade',
    state: 'Estado/Província',
    country: 'País',
    branches: 'Filiais',
    noBranchAvailable: '** Sem filiais disponíveis **'
  }
};

export default branches;